import React, { Component } from 'react'
import PropTypes from 'prop-types'
import fetchApi from '../../services/fetchApi'
import Location from './Location'
import MessageReportSubscription from './MessageReportSubscription'
import css from './practice-locations.css'

class PracticeLocations extends Component {
  static propTypes = {
    hasDSO: PropTypes.bool.isRequired,
    isPracticeAdmin: PropTypes.bool.isRequired,
    hasReminders: PropTypes.bool.isRequired,
  }

  state = {
    locations: [],
  }

  componentDidMount() {
    fetchApi('/account/locations', 'GET')
      .then((locations) => {
        this.setState({ locations })
      })
      .catch((err) => {
        console.error(err)
      })
  }

  render() {
    const { hasDSO, hasReminders, isPracticeAdmin } = this.props
    const showSubscription =
      !!(hasReminders && ((hasDSO && isPracticeAdmin) || !hasDSO))

    return (
      <div className={css.wrapper}>
        {showSubscription && <MessageReportSubscription />}
        {this.state.locations.map((loc, ind) => (
          <Location
            data={loc}
            hasDSO={hasDSO}
            hasReminders={hasReminders}
            key={`${ind}-${loc.name}`}
          />
        ))}
      </div>
    )
  }
}

export default PracticeLocations



// WEBPACK FOOTER //
// ./src/components/Account/PracticeLocation.js